import {
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_BEGIN,
  PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_SUCCESS,
} from './constants'

export function getLineasFinancierasReservado() {
  return async (dispatch, getState) => {
    dispatch({
      type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_BEGIN
    })

    const { presupuestador } = getState()
  

    dispatch({
      type: PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_SUCCESS,
      data: {
        lineas: presupuestador.reservation_credits || []
      }
    })    
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLineasFinancierasPending: true,
        getLineasFinancierasError: null,
        lineasFinancieras: [],
        sinLineasMessage: null
      }

    case PRESUPUESTADOR_GET_LINEAS_FINANCIERAS_RESERVADO_SUCCESS:
      // comprobar si existe una linea seleccionada en el estado
      
      const lineasFinancierasFrizada = action.data.lineas.map(linea => {
        const __linea = { ...linea }
        __linea.cuotasSlider = {}
        linea.lines.forEach(
          cuota => (__linea.cuotasSlider[cuota.quantity] = `${cuota.quantity}`)
        )
        return __linea
      })

      //ordeno las lineas por TASA
      const linesFinanceSort = lineasFinancierasFrizada.map(item=>{
        item.minTNA = Math.min(
          ...item.lines.map(({ tna }) => tna))
        return item
      })
      linesFinanceSort.sort((a,b)=> a.minTNA - b.minTNA)
      
      const lineaSeleccionadaFrizada = linesFinanceSort.find(
        ({ id }) => Number(id) === Number(state.credit_line_id)
        )

      // conservar cuotas, monto y linea financiera si es que existen previamente
      return {
        ...state,
        getLineasFinancierasPending: false,
        getLineasFinancierasError: null,
        lineasFinancieras: linesFinanceSort,
        sinLineasMessage: action.data.message,
        selectedLineaFinanciera: lineaSeleccionadaFrizada
          ? state.selectedLineaFinanciera
          : undefined,
        cuotasAfinanciar: lineaSeleccionadaFrizada
          ? Number(state.credit_line_fees)
          : undefined,
        montoAfinanciar: lineaSeleccionadaFrizada ? state.montoAfinanciar : undefined
      }

    default:
      return state
  }
}
